import React, { forwardRef, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import {
    AppBar,
    Toolbar,
    Typography,
    makeStyles,
    useTheme,
    useMediaQuery,
} from "@material-ui/core";
import { NavbarDrawer } from './NavbarDrawer';
import logo from "../images/logo.png";
import { Modal } from 'react-bootstrap';
import DataService from '../services/data.service';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const useStyles = makeStyles((theme) => ({
    navlinks: {
        display: "flex",
        justifyContent: 'center'
    },
    logo: {
        marginLeft: '3%',
        flexGrow: "0.9",
        cursor: "pointer",
    },
    link: {
        textDecoration: "none",
        color: "black",
        fontSize: "16px",
        fontWeight: "600",
        "&:hover": {
            color: "#a31e21",
        },
    },
}));

export const Navbar = () => {
    const [loading, setLoading] = useState(false);
    const [successOpen, setSuccessOpen] = useState(false);
    const [failOpen, setFailOpen] = useState(false);
    const classes = useStyles();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const url = (window.location.href).split('/')[3];
    const [show, setShow] = useState(false);
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [adsType, setAdsType] = useState("");
    const [influenceMarketing, setInfluenceMarketing] = useState("");
    const [country, setCountry] = useState("");
    const [region, setRegion] = useState("");
    const [city, setCity] = useState("");
    const formType = 'requirement';

    const handleCloseSnackBar = (event, reason) => {
        setSuccessOpen(false);
        setFailOpen(false);
    };

    useEffect(() => {
        if (url === "") {
            setTimeout(() => {
                setShow(true);
            }, 1500);
        }
        // eslint-disable-next-line
    }, [])

    const handleAction = () => {
        setShow(true);
    }

    const handleClose = () => setShow(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);

        const data = new FormData();
        data.append('name', firstName + " " + lastName);
        data.append('email', email);
        data.append('phone', phone);
        data.append('adsType', adsType);
        data.append('influenceMarketing', influenceMarketing);
        data.append('country', country);
        data.append('state', region);
        data.append('city', city);
        data.append('formType', formType);

        DataService.sendMail(data)
            .then((response) => {
                if (response.message === 'success') {
                    setSuccessOpen(true);
                    setLoading(false);
                }
                else {
                    setFailOpen(true);
                    setLoading(false);
                }
                setShow(false)
                setFirstName("");
                setLastName("");
                setEmail("");
                setPhone("");
                setAdsType("");
                setInfluenceMarketing("");
                setCountry("");
                setRegion("");
                setCity("");
            })
    }

    return (
        <div>
            <Snackbar open={successOpen} autoHideDuration={10000} onClose={handleCloseSnackBar}>
                <Alert onClose={handleClose} severity="success" sx={{ width: '100%' }}>
                    This is a success message!
                </Alert>
            </Snackbar>
            <Snackbar open={failOpen} autoHideDuration={10000} onClose={handleCloseSnackBar}>
                <Alert onClose={handleClose} severity="warning" sx={{ width: '100%' }} >
                    This is a warning message!
                </Alert>
            </Snackbar>
            <AppBar position="static" style={{ backgroundColor: 'white' }}>
                <Toolbar>
                    <Typography variant="h4" className={classes.logo}>
                        <div className="site--logo" data-toggle="tooltip" data-placement="top" title="Firshtey Media">
                            <a href="/" className="custom-logo-link" rel="home" aria-current="page">
                                <img width="1" height="30" src={logo} class="custom-logo" alt="Frishtey Media" />
                            </a>
                        </div>
                    </Typography>
                    {isMobile ? (
                        <NavbarDrawer />
                    ) :
                        (<header class="header-area header-sticky wow slideInDown" data-wow-duration="0.75s" data-wow-delay="0s">
                            <div class="container">
                                <div class="row">
                                    <div class="col-12">
                                        <nav class="main-nav">
                                            <Link to="/" class="logo">
                                                <img src={logo} alt="Frishtey Media" />
                                            </Link>
                                            <ul class="nav">
                                                <li class="scroll-to-section">
                                                    {
                                                        url === "" ?
                                                            <Link to="/">
                                                                <span style={{ color: '#a31e21' }}>Home</span>
                                                            </Link>
                                                            :
                                                            <Link to="/">
                                                                <span>Home</span>
                                                            </Link>
                                                    }
                                                </li>
                                                <li class="scroll-to-section">
                                                    {
                                                        url === "services" ?
                                                            <>
                                                                <div class="dropdown1">
                                                                    <span>
                                                                        <span className={classes.link} style={{ color: '#a31e21', cursor: 'pointer', letterSpacing: '1px' }}>Services</span>
                                                                    </span>
                                                                    <div class="dropdown-content">
                                                                        <Link to="/services/seo-and-web-analytics">
                                                                            <span className={classes.link}>SEO & Web Analytics</span>
                                                                        </Link>
                                                                        <Link to="/services/online-advertisement">
                                                                            <span className={classes.link}>Online Advertisement</span>
                                                                        </Link>
                                                                        <Link to="/services/poster-and-logo-design">
                                                                            <span className={classes.link}>Poster & Logo Design</span>
                                                                        </Link>
                                                                        <Link to="/services/web-design-and-development">
                                                                            <span className={classes.link}>Web Design & Development</span>
                                                                        </Link>
                                                                        <Link to="/services/video-editing-and-animation">
                                                                            <span className={classes.link}>Video Editing & Animation</span>
                                                                        </Link>
                                                                    </div>
                                                                </div>
                                                            </>
                                                            :
                                                            <div class="dropdown1">
                                                                <span>
                                                                    <span className={classes.link} style={{ cursor: 'pointer', letterSpacing: '1px' }}>Services</span>
                                                                </span>
                                                                <div class="dropdown-content">
                                                                    <Link to="/services/seo-and-web-analytics">
                                                                        <span className={classes.link}>SEO & Web Analytics</span>
                                                                    </Link>
                                                                    <Link to="/services/online-advertisement">
                                                                        <span className={classes.link}>Online Advertisement</span>
                                                                    </Link>
                                                                    <Link to="/services/poster-and-logo-design">
                                                                        <span className={classes.link}>Poster & Logo Design</span>
                                                                    </Link>
                                                                    <Link to="/services/web-design-and-development">
                                                                        <span className={classes.link}>Web Design & Development</span>
                                                                    </Link>
                                                                    <Link to="/services/video-editing-and-animation">
                                                                        <span className={classes.link}>Video Editing & Animation</span>
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                    }
                                                </li>
                                                <li class="scroll-to-section">
                                                    {
                                                        url === "contact" ?
                                                            <Link to="/contact">
                                                                <span style={{ color: '#a31e21' }}>Contact</span>
                                                            </Link>
                                                            :
                                                            <Link to="/contact">
                                                                <span>Contact</span>
                                                            </Link>
                                                    }
                                                </li>
                                                <li class="scroll-to-section">
                                                    <div class="border-first-button" onClick={handleAction}>
                                                        <span>Free Quote</span>
                                                    </div>
                                                </li>
                                            </ul>
                                            <div class="menu-trigger">
                                                <span>
                                                    Menu
                                                </span>
                                            </div>
                                        </nav>
                                    </div>
                                </div>
                            </div>
                        </header>)}
                </Toolbar>
            </AppBar>
            <Modal show={show} onHide={handleClose} size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <div id="contact" class="section">
                    <div class="row">
                        <div class="col-lg-12 wow fadeInUp" data-wow-duration="0.5s" data-wow-delay="0.25s">
                            <form id="contact" onSubmit={handleSubmit}>
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="fill-form">
                                            <div className='row' style={{ textAlign: 'start' }}>
                                                <div className='col-md-6'>
                                                    <label className='form-label'>Name <span style={{ color: 'red' }}> *</span></label>
                                                    <input type="text" placeholder='First Name' className='form-control inputbox' required
                                                        value={firstName} onChange={e => setFirstName(e.target.value)}></input>
                                                </div>
                                                <div className='col-md-6'>
                                                    <label className='form-label'><span style={{ color: 'transparent' }}> *</span></label>
                                                    <input type="text" placeholder='Last Name' className='form-control inputbox' required
                                                        value={lastName} onChange={e => setLastName(e.target.value)}></input>
                                                </div>
                                                <div className='col-md-6'><br />
                                                    <label className='form-label'>Email <span style={{ color: 'red' }}> *</span></label>
                                                    <input type="text" placeholder='Your Email' className='form-control inputbox' required
                                                        value={email} onChange={e => setEmail(e.target.value)}></input>
                                                </div>
                                                <div className='col-md-6'><br />
                                                    <label className='form-label'>Phone <span style={{ color: 'red' }}> *</span></label>
                                                    <input type="text" placeholder='Your Phone' className='form-control inputbox' required
                                                        value={phone} onChange={e => setPhone(e.target.value)}></input>
                                                </div>
                                                <div className='col-md-6'><br />
                                                    <label className='form-label'>Advertisement Type <span style={{ color: 'red' }}> *</span></label>
                                                    <select className='form-control inputbox' required value={adsType} onChange={e => setAdsType(e.target.value)}>
                                                        <option>Select</option>
                                                        <option>L Shape Video</option>
                                                        <option>Short Promo Video (30 seconds)</option>
                                                        <option>Full Promo Video (10 - 30 minutes)</option>
                                                    </select>
                                                </div>
                                                <div className='col-md-6'><br />
                                                    <label className='form-label'>Influence Marketing <span style={{ color: 'red' }}> *</span></label>
                                                    <select className='form-control inputbox' required value={influenceMarketing} onChange={e => setInfluenceMarketing(e.target.value)}>
                                                        <option>Select</option>
                                                        <option>Yes</option>
                                                        <option>No</option>
                                                    </select>
                                                </div>
                                                <div className='col-12'><br /></div>
                                                <div className='col-md-4'>
                                                    <label className='form-label'>Location <span style={{ color: 'red' }}> *</span></label>
                                                    <input type="text" placeholder="Country" className='form-control inputbox' required
                                                        value={country} onChange={e => setCountry(e.target.value)} />
                                                </div>
                                                <div className='col-md-4'>
                                                    <label className='form-label'><span style={{ color: 'transparent' }}> *</span></label>
                                                    <input type="text" placeholder="State" className='form-control inputbox' required
                                                        value={region} onChange={e => setRegion(e.target.value)} />
                                                </div>
                                                <div className='col-md-4'>
                                                    <label className='form-label'><span style={{ color: 'transparent' }}> *</span></label>
                                                    <input type="text" placeholder="City" className='form-control inputbox' required
                                                        value={city} onChange={e => setCity(e.target.value)} />
                                                </div>
                                                <div className='col-md-3'></div>
                                                <div className='col-md-6'>
                                                    {
                                                        loading ?
                                                            <button type="submit" className='btn-submit' disabled>
                                                                <span className="spinner-border spinner-border-sm"></span>&nbsp;
                                                                Loading...
                                                            </button>
                                                            :
                                                            <button type="submit" className='btn-submit'>
                                                                Submit
                                                            </button>
                                                    }
                                                </div>
                                                <div class="border-first-button btn-hidden-submit" >
                                                    <span>Submit</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    )
}
